import { render } from "./nqr-payment.vue?vue&type=template&id=09266321&scoped=true"
import script from "./nqr-payment.vue?vue&type=script&lang=js"
export * from "./nqr-payment.vue?vue&type=script&lang=js"

import "./nqr-payment.vue?vue&type=style&index=0&id=09266321&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09266321"]])

export default __exports__